import { z } from 'zod';
import { collectionNameSchema } from './collections';

// Sync protocol. Every change bumps a per-user version counter; a client remembers the last
// version it pulled and asks only for what came after. See docs/ARCHITETTURA.md §7.

export const MAX_MUTATIONS_PER_PUSH = 500;

export const mutationSchema = z.discriminatedUnion('op', [
  z.object({
    op: z.literal('upsert'),
    collection: collectionNameSchema,
    id: z.uuid(),
    /** Only the fields that changed (all of them when the record is new). */
    fields: z.record(z.string(), z.unknown()),
  }),
  z.object({
    op: z.literal('delete'),
    collection: collectionNameSchema,
    id: z.uuid(),
  }),
]);
export type Mutation = z.infer<typeof mutationSchema>;

export const pushRequestSchema = z.object({
  mutations: z.array(mutationSchema).min(1).max(MAX_MUTATIONS_PER_PUSH),
});
export type PushRequest = z.infer<typeof pushRequestSchema>;

export const pushResponseSchema = z.object({
  version: z.number().int(),
  /** Mutations the server refused (invalid data): the client drops them. */
  rejected: z.array(
    z.object({ collection: collectionNameSchema, id: z.uuid(), message: z.string() }),
  ),
});
export type PushResponse = z.infer<typeof pushResponseSchema>;

export const pullResponseSchema = z.object({
  version: z.number().int(),
  /** True when the client's cursor was unknown: it must replace its local data with `changes`. */
  reset: z.boolean(),
  changes: z.partialRecord(collectionNameSchema, z.array(z.record(z.string(), z.unknown()))),
});
export type PullResponse = z.infer<typeof pullResponseSchema>;
